module.exports = __webpack_public_path__ + "assets/img/9-2.cd97a7af.png";